const domain = "https://api.xpens.cn";
export default {
    domain:domain
}

// 根据机构类型导出相关信息
export function getOrgInfo(type) {
  // 小友易学
  let org_education =  {
    "domain": "cloud.xpens.cn",
    "client_id": 2,
    "loginBtnColor":'#f50100',

    "CopyRightFirstHref":'https://beian.miit.gov.cn/',
    "CopyRightSecondHref":'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502045518',
    "CopyRightFirst":'京ICP备2020034967号-1',
    "CopyRightSecond":'京公网安备 11010502045518号',
    'btnShow':false,
    'addTeacherBtn':true,
    "showCodeImg": true,
    "ai_print_fields": true,
    "evaluate":0,
    "bigQues":'大题',
    'quick_login': '0',


    "title": "小友易学",
    "login_title": "系统登录 - 小友",
    "login_type":'1',
    'oid':'2',
    "companyTit":"北京小友科技有限公司",
    "logo":require("../assets/404_images/logo_white_education.png"),
    "form_logo":require("../assets/404_images/logo_red_education.png"),
    "background_image": require("../assets/404_images/bg_education.png"),
    "side_max_logo":require("../images/logo/side_logo_max.png"),
    "side_min_logo":require("../images/logo/side_logo_min.png"),
    "side_logo":require("../images/logo_menu_education.png"),
    "favor_icon": "icon_education.png",
    "adminRole":"教师",
    "member":"学生",
    "grade":"学校",
    "grouping":"年级",
    "class":"班级",
    "subjects":"科目",
    "manageClass":"任课班级",
    "departmentManager":"班主任",
    'submanage':'年级主任',
    "transferClass":"转班",
    "studentNumber":"学号",
    "downClientUrl":'',
    'teacher':'老师',
    'gzhImg':require("../images/qrcode/gzh_xy.jpeg"),
    'xcxImg':require("../images/qrcode/xcx_xy.jpeg"),

    // 贵州  ../images/qrcode/gzh_gz.jpeg
    // 贵州   ../images/qrcode/xcx_gz.jpeg


    // "title": "青蓝联创",
    // 'oid': '1017',
    // "login_type":'2',
    // "companyTit":"陆军防化学院教务处",
    // "logo":require("../assets/404_images/logo_white_qinglan.png"),
    // "form_logo":require("../assets/404_images/logo_red_qinglan.png"),
    // "background_image": require("../assets/404_images/bg_qinglan.png"),
    // "side_max_logo":require("../images/logo/side_logo_max_qllc.png"),
    // "side_min_logo":require("../images/logo/side_logo_min.png"),
    // "side_logo":require("../images/logo_menu_education.png"),
    // "favor_icon": "icon_education.png",
    // "adminRole":"教员",
    // "member":"学员",
    // "grade":"学校",
    // "grouping":"年级",
    // "class":"区队",
    // "subjects":"专业",
    // "manageClass":"任课班级",
    // "departmentManager":"班主任",
    // 'submanage':'年级主任',
    // "transferClass":"转班",
    // "studentNumber":"学号",
    // "downClientUrl":'www.baidu.com',
    // "officeTitle":'教研室',
    // "officeClass":'科室',
    // "officeGrouping":"部门",
    // "officeTeacherName":'教师',


    // "title": "金州纸笔课堂",
    // "login_type":'1',
    // "companyTit":"中国电信股份有限公司黔西南分公司",
    // "logo":require("../assets/404_images/logo_white_education.png"),
    // "form_logo":require("../assets/404_images/logo_red_education.png"),
    // "background_image": require("../assets/404_images/bg_education.png"),
    // "side_max_logo":require("../images/logo/side_logo_max_jzzbkt.png"),
    // "side_min_logo":require("../images/logo/side_logo_min.png"),
    // "side_logo":require("../images/logo_menu_education.png"),
    // "favor_icon": "icon_education.png",
    // "adminRole":"教师",
    // "member":"学生",
    // "grade":"学校",
    // "grouping":"年级",
    // "class":"班级",
    // "subjects":"科目",
    // "manageClass":"任课班级",
    // "departmentManager":"班主任",
    // 'submanage':'年级主任',
    // "transferClass":"转班",
    // "studentNumber":"学号",
    // "downClientUrl":'',


  }
  // 小友办公
  let org_business = {

    "CopyRightFirstHref":'https://beian.miit.gov.cn/',
    "CopyRightSecondHref":'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502045518',
    "CopyRightFirst":'京ICP备2020034967号-1',
    "CopyRightSecond":'京公网安备 11010502045518号',
    'btnShow': true,
    'showHtml': true,
    "showCodeImg": true,
    "ai_print_fields": true,
    'addTeacherBtn': true,
    "evaluate":0,
    'quick_login': '0',


    "domain": "data.xpens.cn",
    "client_id": 4,
    "title": "小友办公 - 小友",
    "login_type":'3',
    "companyTit":"北京小友科技有限公司",
    "loginBtnColor":'#409eff',
    "logo":require("../assets/404_images/logo_white_business.png"),
    "form_logo":require("../assets/404_images/logo_red_business.png"),
    "background_image": require("../assets/404_images/bg_business.png"),
    "side_max_logo":require("../images/logo/side_logo_max_xybg.png"),
    "side_min_logo":require("../images/logo/side_logo_min.png"),
    "side_logo":require("../images/logo_menu_business.png"),
    "favor_icon": "icon_business.png",
    "adminRole":"管理员",
    "member":"员工",
    "grade":"单位",
    "grouping":"分组",
    "class":"部门",
    "subjects":"科目",
    "manageClass":"负责部门",
    "departmentManager":"部门管理员",
    'submanage':'区域管理员',
    "transferClass":"转部门",
    "studentNumber":"工号",
    "downClientUrl":'',
    "bigQues":'大题',

  }
  // 党建智慧笔记
  let org_dang = {

    "CopyRightFirstHref":'https://beian.miit.gov.cn/',
    "CopyRightSecondHref":'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502045518',
    "CopyRightFirst":'京ICP备2020034967号-1',
    "CopyRightSecond":'京公网安备 11010502045518号',
    'showHtml': true,
    'btnShow': false,
    "showCodeImg": true,
    "ai_print_fields": true,
    "evaluate":0,
    'quick_login': '0',



    "domain": "{{domain_dang}}",
    "client_id": 2,
    "title": "智慧学习笔记",
    "login_type":'4',
    "companyTit":"北京《中华魂》网络信息中心 主办 \n "+
    "北京小友科技有限公司 协办",
    "loginBtnColor":'#F41C1C',
    "logo":require("../images/logo_white_dang.png"),
    "form_logo":require("../images/logo_red_dang.png"),
    "background_image": require("../images/bg_dang.png"),


    "side_max_logo":require("../images/logo/side_logo_max_zhxx.png"),
    "side_logo":require("../images/icon_dang.png"),
    "favor_icon": "icon_business.png",
    "adminRole":"管理员",
    "member":"党员",
    "grade":"单位",
    "grouping":"单位",
    "class":"党支部",
    "subjects":"科目",
    "manageClass":"负责部门",
    "departmentManager":"超级管理员",
    "transferClass":"转支部",
    "studentNumber":"手机号",
    "downClientUrl":'',
    "bigQues":'大题',
  }

  // 云启智学

  let org_yunqi = {

    "CopyRightFirstHref":'https://beian.miit.gov.cn/',
    "CopyRightSecondHref":'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502045518',
    "CopyRightFirst":'陕ICP备2022001303号-1',
    "CopyRightSecond":'',
    'showHtml': true,
    'btnShow': false,
    "showCodeImg": false,
    "ai_print_fields": true,
    'addTeacherBtn': true,
    "evaluate":0,
    'quick_login': '0',


    "domain": "www.yqpen.com",
    "client_id": 2,
    "title": "云启智学",
    "login_type":'5',
    'oid':'1',
    "companyTit":"云启未来(西安)科技有限责任公司",

    "loginBtnColor":'#F41C1C',

    "logo":require("../assets/404_images/yunqi_logo11.png"),
    "form_logo":require("../assets/404_images/yunqi_login.png"),
    "background_image": require("../assets/404_images/bg_education.png"),
    "side_max_logo":require("../images/logo/side_logo_max_yqzx.png"),
    "side_min_logo":require("../images/logo/side_logo_min_yqzx.png"),
    "side_logo":require("../assets/404_images/logo_white_yunqi.png"),
    "favor_icon": "icon_yunqi1.png",
    'xcxImg':require("../images/qrcode/xcx_yq.jpeg"),

    "adminRole":"教师",
    "member":"学生",
    "grade":"学校",
    "grouping":"年级",
    "class":"班级",
    "subjects":"科目",
    "manageClass":"任课班级",
    "departmentManager":"班主任",
    'submanage':'年级主任',
    "transferClass":"转班",
    "studentNumber":"学号",
    "downClientUrl":'',
    "bigQues":'大题',
    'teacher':'老师',

  }
  // 纸笔协同
  let org_zbxt = {

    "CopyRightFirstHref":'https://beian.miit.gov.cn/',
    "CopyRightSecondHref":'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502045518',
    "CopyRightFirst":'京ICP备2020034967号-1',
    "CopyRightSecond":'京公网安备 11010502045518号',
    'btnShow': true,
    "showCodeImg": true,
    "ai_print_fields": true,
    'addTeacherBtn':true,
    "evaluate":0,
    'quick_login': '0',

    "domain": "record.xpens.cn",
    "client_id": 4,
    "title": "纸笔协同 - 小友",
    "login_type":'3',
    "companyTit":"",
    "loginBtnColor":'#409eff',
    "logo":require("../images/admin_logo_business.png"),
    "form_logo":require("../images/admin_login_business.png"),
    "background_image": require("../assets/404_images/bg_business.png"),
    "side_max_logo":require("../images/logo/side_logo_max_zbxt.png"),
    "side_min_logo":require("../images/logo/side_logo_min.png"),
    "side_logo":require("../images/logo_menu_business.png"),
    "favor_icon": "icon_business.png",
    "adminRole":"管理员",
    "member":"员工",
    "grade":"单位",
    "grouping":"区域",
    "class":"项目",
    "subjects":"科目",
    "manageClass":"负责部门",
    "departmentManager":"部门管理员",
    'submanage':'区域管理员',
    "transferClass":"转部门",
    "studentNumber":"工号",
    "downClientUrl":'',
  }

  // 德威视创
  let org_dowellsoft = {
    "CopyRightFirstHref":'https://beian.miit.gov.cn/',
    "CopyRightSecondHref":'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502045518',
    "CopyRightFirst":'京ICP备2020034967号-1',
    "CopyRightSecond":'京公网安备 11010502045518号',
        
    'showHtml': true,
    'btnShow': false,
    "showCodeImg": false,
    "ai_print_fields": true,
    'addTeacherBtn': true,
    "evaluate":0,
    'quick_login': '0',


    "domain": "dowellsoft.xpens.cn",
    "client_id": 2,
    "title": "德威视创",
    "login_type":'5',
    'oid':'1',
    "companyTit":"北京德威视创软件技术有限公司",

    "loginBtnColor":'#F41C1C',

    "logo":require("../assets/404_images/dowellsoft.png"),
    "form_logo":require("../assets/404_images/yunqi_login.png"),
    "background_image": require("../assets/404_images/bg_education.png"),
    "side_max_logo":require("../assets/404_images/dowellsoft.png"),
    "side_min_logo":require("../images/logo/side_logo_dowellsoft.png"),
    "side_logo":require("../images/logo_menu_education.png"),
    "favor_icon": "icon_dowellsoft.png",

    "adminRole":"教师",
    "member":"学生",
    "grade":"学校",
    "grouping":"年级",
    "class":"班级",
    "subjects":"科目",
    "manageClass":"任课班级",
    "departmentManager":"班主任",
    'submanage':'年级主任',
    "transferClass":"转班",
    "studentNumber":"学号",
    "downClientUrl":'',
    "bigQues":'大题',
    'teacher':'老师',

  }  
  let orgInfo = org_education
  if(type == 'business'){ // 教育
    orgInfo = org_business
  }else if(type == 'dang'){
    orgInfo = org_dang
  }else if(type == 'yunqi'){
    orgInfo = org_yunqi
  }else if(type == 'zbxt'){
    orgInfo = org_zbxt
  }else if(type == 'dowellsoft'){
    orgInfo = org_dowellsoft
  }
  return orgInfo
}

export function getOrgList() {

  var orgListArr = ['business', 'yunqi', 'dang', 'zbxt', 'dowellsoft', 'education']
  return orgListArr
}
